/* CR-03: keep homepage on the clean root URL with the intentional SEO title. */
(function () {
  try {
    var path = (window.location.pathname || '').replace(/\/+$/, '') || '/';
    if (path !== '/') return;

    var q = window.location.search || '';
    var hash = window.location.hash || '';
    var html = document.documentElement ? document.documentElement.innerHTML : '';
    var hasOldForcer = /params\.set\(\s*['"]page['"]\s*,\s*['"]109['"]\s*\)/.test(html);
    var title = document.title || '';
    var goodTitle = /Electronics,\s*Home,\s*Beauty/i.test(title);
    var badTitle = title === 'Good Deal Superstore' || /Page\s*109/i.test(title);

    function cleanRoot() {
      window.history.replaceState(null, '', '/' + hash);
    }

    // Fresh renders: strip leftover cache-bust query params without reloading.
    if (q && /[?&](page|view|_cr03|_fd|pb)=/.test(q) && !hasOldForcer) {
      cleanRoot();
      return;
    }

    // Stale CDN copy still forces ?page=109 — hop once via view= (cache-busts), then clean.
    if (hasOldForcer || (badTitle && !goodTitle)) {
      if (/[?&]view=cr03(?:&|$)/.test(q)) {
        cleanRoot();
        return;
      }
      if (window.sessionStorage && sessionStorage.getItem('gds_cr03_home') === '1') {
        cleanRoot();
        return;
      }
      try {
        if (window.sessionStorage) sessionStorage.setItem('gds_cr03_home', '1');
      } catch (e) {}
      window.location.replace('/?view=cr03' + hash);
    }
  } catch (e) {}
})();
